(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrResourceDeleteController',TrResourceDeleteController);

    TrResourceDeleteController.$inject = ['$uibModalInstance', 'entity', 'TrResource','$scope'];

    function TrResourceDeleteController($uibModalInstance, entity, TrResource,$scope) {
        var vm = this;

        vm.trResource = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
        	$scope.deletefail = true;
            TrResource.delete({id: id},
                function () {
            	
            	 $scope.deletefail = false;
                    $uibModalInstance.close(true);
                });
           
        }
    }
})();
